import { t } from '../../../../i18n.es.js';
import React, { useState } from 'react';
import { styled, Button } from '@teko/ui';
import { RatingStars } from '../RatingStars/RatingStars.es.js';

const Divider = styled.hr`
  margin: 0 16px;
  width: 90%;
`;
const Form = styled.div`
  padding: 15px;
  margin: 0 auto;
  margin-top: 30px;
  border-radius: 10px;
  background-color: #f6f6f6;
  width: 100%;
`;
const CommentTitle = styled.div`
  height: 19px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.11px;
  color: #000000;
  margin-bottom: 13px;
`;
const InputGroup = styled.div`
  display: block;
  margin-top: 15px;
`;
const FormLabel = styled.label`
  width: 200px;
`;
const CommentBox = styled.textarea`
  flex: 1;
  border-radius: 3px;
  padding: 0;
  outline: none;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  font-size: 14px;
  background-color: white;
  line-height: 1.5;
  &::-webkit-input-placeholder {
    font-size: 12px;
    color: #999;
  }
  border: solid 1px #e0e0e0;
  width: 100%;
  resize: none;
`;
const StyledButton = styled(Button)(({ theme }) => `
  margin-top: 24px;
  width: 100%;
  background: ${theme == null ? void 0 : theme.brand.primary};
  color: #fff;
  padding: 12px;
  &:hover {
    color: ${theme == null ? void 0 : theme.brand.primary};
    background: #fff;
  }
  text-align: center;
  justify-content: center;
`);
const ReviewForm = ({
  onSendRating
}) => {
  const [rating, setRating] = useState(-1);
  const [comment, setComment] = useState("");
  const handleAddComment = (e) => {
    setComment(e.target.value);
  };
  return /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(CommentTitle, null, t("Nh\u1EADn x\xE9t c\u1EE7a b\u1EA1n")), /* @__PURE__ */ React.createElement(Divider, null), /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(FormLabel, null, t("1. \u0110\xE1nh gi\xE1 v\u1EC1 s\u1EA3n ph\u1EA9m:")), /* @__PURE__ */ React.createElement(RatingStars, {
    stars: -1,
    onStarClicked: (star) => setRating(star),
    starWidth: 20
  })), /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(FormLabel, null, t("2. Vi\u1EBFt nh\u1EADn x\xE9t:")), /* @__PURE__ */ React.createElement(CommentBox, {
    value: comment,
    onChange: handleAddComment,
    rows: 5,
    placeholder: t("Nh\u1EADn x\xE9t v\u1EC1 s\u1EA3n ph\u1EA9m")
  }, comment)), /* @__PURE__ */ React.createElement(StyledButton, {
    onClick: () => onSendRating(rating, comment)
  }, /* @__PURE__ */ React.createElement("strong", null, t("G\u1EEDi nh\u1EADn x\xE9t"))));
};

export { ReviewForm };
